import { AssessmentCriteriaField } from '@/components/evaluation/AssessmentItemForm';
import { AssessmentCriteria } from '@/models/Assessment';

export const adaptCriteriaAssessmentForm = (
  criterion: AssessmentCriteria,
): AssessmentCriteriaField => ({
  id: criterion.id,
  name: criterion.name,
  description: criterion.description ?? undefined,
  maxGrade: criterion.maxGrade,
  activityType: criterion.activityType ?? '',
});
